import { FiPieChart, FiSearch, FiBarChart, FiTrendingUp } from "react-icons/fi";

export const otherMenuItems = [
  {
    menuLabel: "Databases",
    icon: <FiSearch />,
    items: [
      { to: "/companies", menuLabel: "Startups & Companies" },
      { to: "/investors", menuLabel: "Investors" },
      { to: "/deals", menuLabel: "Deals" },
      {
        to: "/funds",
        menuLabel: "Funds & Limited Partners",
      },
      { to: "/esos", menuLabel: "Ecosystem Support Organizations" },
      { to: "/events", menuLabel: "Events & Conferences" },
    ],
  },
  {
    menuLabel: "Market Intelligence",
    icon: <FiBarChart />,
    items: [
      {
        to: "/industry-pulse",
        menuLabel: "Ecosystem Feed",
      },
      {
        to: "/market-intelligence",
        menuLabel: (
          <>
            Market Signals <sup className="text-[8px] ">BETA</sup>
          </>
        ),
      },
      {
        to: "/research",
        menuLabel: "Market Reports",
      },
      {
        to: "/comparison",
        menuLabel: "Regional Overview",
      },
    ],
  },
];

/**
 * InvestorsKit menu structure for INVESTOR persona
 * Defines the navigation menu items and sub-items
 */
export const investorMenuItems = [
  {
    menuLabel: "Portfolio Intelligence",
    icon: <FiPieChart />,
    items: [
      {
        to: "/portfolio-companies",
        menuLabel: "Portfolio Overview",
      },
      {
        to: "/venture-radar",
        menuLabel: "Venture Scout",
      },
      {
        to: "/co-investor-network",
        menuLabel: "Co-Investor Network",
      },
    ],
  },
  ...otherMenuItems,
];
